var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('pie-chart',{attrs:{"legendData":_vm.legendData,"series":_vm.series,"type":'gender'}}),_c('p',{staticClass:"charttips"},[_vm._v("说明：图示为所选统计区间各性别赔付金额")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }